import { PRAGMATIC_LIVE_TABLE_TYPE } from '~/components/Lobby/enum'
import { formatNumberFilter } from '~/util/helpers/vueFilters'

export const normalizeLiveTablesMessage = (message) => {
  const tableType = message.tableType
  const isRoulette = tableType === PRAGMATIC_LIVE_TABLE_TYPE.ROULETTE
  const isBaccarat = tableType === PRAGMATIC_LIVE_TABLE_TYPE.BACCARAT
  const isBlackjack = tableType === PRAGMATIC_LIVE_TABLE_TYPE.BLACKJACK
  const isDefault = !isRoulette && !isBaccarat && !isBlackjack
  const usersTextLeft = isBlackjack
    ? ['seat1', 'seat2', 'seat3', 'seat4', 'seat5', 'seat6', 'seat7']
      .reduce((c, field) => {
        if (message[field]) return c + 1
        return c
      }, 0)
    : message.totalSeatedPlayers
  const usersTextRight = `${!isBlackjack ? '' : ' / 7'}`
  const usersText = `${usersTextLeft}${usersTextRight}`
  return {
    ...message,
    minBetGrn: formatNumberFilter(message?.tableLimits?.minBet),
    usersText,
    tableType: {
      value: tableType,
      isRoulette,
      isBaccarat,
      isBlackjack,
      isDefault,
    },
  }
}
